import ability from "@utils/ability";
import { fetcherNew1819 } from "@utils/fetcherNew1819";
import { localStorageUtil } from "@utils/storage";
import updateAbility from "@utils/updateAbility";
import jwt from "jsonwebtoken";
import Router from "next/router";

export const types = {
    user_logged_in: "user_logged_in",
    user_logged_out: "user_logged_out",
    login_error: "login_error",
    set_tokens: "set_tokens",
    refresh_access_token: "refresh_access_token",
    get_user: "get_user",
};

let logoutRedirectTimeout = null;

export const setAccessToken = (access_token) => async (dispatch) => {
    try {
        let jwtPayload = await jwt.verify(access_token, process.env.ACCESS_TOKEN_PUBLIC_KEY, {
            algorithms: ["RS256"],
        });
        dispatch({ type: types.user_logged_in, payload: { user: jwtPayload, access_token } });

        localStorageUtil.setItem("user", jwtPayload);
        localStorageUtil.setItem("access_token", access_token);
        dispatch(getUser());
    } catch (e) {
        console.log(e);
    }
};

export const refreshAccessToken = () => (dispatch) => {
    fetcherNew1819("token", "POST")
        .then(async (data) => {
            localStorageUtil.setItem("access_token", data.access_token);
            await dispatch(setAccessToken(data.access_token));
            localStorage.setItem("access_token", data.access_token);
            await new Promise((resolve) => setTimeout(resolve, 100));
        })
        .catch((e) => {
            dispatch({ type: types.login_error, payload: e.message });
        });
};

export const getUser = () => async (dispatch, getState) => {
    // log stack trace
    console.trace();
    if (!getState()?.auth?.user) {
        return;
    }
    try {
        let user = await fetcherNew1819("user");
        dispatch({ type: types.get_user, payload: user });
        localStorageUtil.setItem("user", user);
        updateAbility(ability, user);
    } catch (e) {
        console.log(e);
        if (e.statusCode == 401) {
            dispatch(refreshAccessToken());
        }
        return;
    }
};

export const logUserOut = () => async (dispatch) => {
    try {
        // remove from redux's user state
        dispatch({ type: types.user_logged_out, payload: null });

        // Clear local storage
        localStorageUtil.removeItem("user");
        localStorageUtil.removeItem("access_token");

        // Call logout endpoint
        await fetcherNew1819("logout", "POST");

        // Clear any pending redirect to avoid duplicate calls
        if (logoutRedirectTimeout) {
            clearTimeout(logoutRedirectTimeout);
        }

        // Redirect to home page
        Router.replace("/");
    } catch (error) {
        console.error("Error during logout:", error);
        // Still try to redirect even if there's an error
        Router.replace("/");
    }
};

export const loginExpired = () => (dispatch, getState) => {
    if (!getState()?.auth?.user) {
        return;
    }
    dispatch({ type: types.user_logged_out, payload: null });
    localStorageUtil.removeItem("user");
    localStorageUtil.removeItem("access_token");
    if (Router.pathname.startsWith("/mitt")) {
        Router.push("/");
    }
};
